
import { Component, Vue } from 'vue-property-decorator'
import { CourseModule } from '../../store/modules/course'
import CourseList from '../../components/course/course-list.vue'
import { formatDate } from '../../utils/publish'

@Component({
  name: 'package',
  components: { CourseList }
})
export default class extends Vue {
  org_id: string = 'd06455545e6d4b929f4fbacbdc93dd24'
  list: any = []
  header: any = []
  headerTop: any = []
  page: any = {}
  upId: string = ''
  optionId: string = ''
  pageName: string = ''
  allData: any = {}

  async getList() {
    const res: any = await CourseModule.orderPage({ org_id: this.org_id })
    if (res.code === 200) {
      this.list = res.data.page_section[0].entity.entity_data
      this.list = []
      this.header = res.data.page_section[0].entity.entity_fields
      this.headerTop = this.header
      this.page = res.data.page_section[0].entity.page
      this.upId = res.data.page_section[0].id
      this.optionId = res.data.page_section[0].entity.id
      this.pageName = res.data.key
      this.allData = res.data
    }
  }

  async pageLogs(newArr, val) {
    const data_id = newArr.join(',')
    const res: any = await CourseModule.pageLogs({ data_id: data_id, page_name: 'edu-order-page'})
    if(res.code === 200) {
      if(res.data.list && res.data.list.length > 0) {
         for(var i = 0; i < res.data.list.length; i++) {
           for (var j = 0; j < val.data.length; j++) {
             if(res.data.list[i].data_id === val.data[j].id) {
               const log = res.data.list[i].option_content
               let str = ''
               const employee_name = res.data.list[i].employee_name
               const create_time = formatDate(res.data.list[i].create_time, 2)
               const remark = res.data.list[i].remark
               for (var k in res.data.list[i].option_content) {
                 str += '将' + k + ':' + res.data.list[i].option_content[k][0] + '修改为' + res.data.list[i].option_content[k][1] + ','
               }
               val.data[j]['option_customer_title'] =  employee_name + create_time
               val.data[j]['option_customer_content'] =  str
               val.data[j]['option_customer_remark'] =  remark
             }
           }
         }
      }
      this.list = val.data
      this.allData = val.allData
    }
  }

  async upList(val) {
    let newArr = (val.data).map((item, index)=>{
      return item.id
    })
    this.pageLogs(newArr, val)
  }
  mounted() {
    this.getList()
  }
}
